import React from 'react';
import { Icon } from '@iconify/react';

const GroupDataTable = ({ groups, onEdit, onDelete, loading }) => {
  return (
    <table className="table bordered-table mb-3" style={{ width: '100%', borderRadius: '0' }}>
      <thead>
        <tr>
          <th style={{ borderRadius: '0' }}></th>
          <th>Group Name</th>
          <th>Class</th>
          <th>Manufacturer</th>
          <th style={{ borderRadius: '0' }}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {groups.map((row, index) => (
          <tr key={`${row.id}-${index}`}>
            <td>
              <img
                src={
                  row.groupImage
                    ? `${process.env.REACT_APP_SPACES_BASE}/${row.groupImage}`
                    : `${process.env.REACT_APP_SPACES_BASE}/placeholder.png`
                }
                alt="group"
                style={{ width: '45px', height: '45px', borderRadius: '50%', objectFit: 'cover', border: '1px solid #ddd' }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = `${process.env.REACT_APP_SPACES_BASE}/placeholder.png`;
                }}
              />
            </td>
            <td><strong>{row.groupName}</strong></td>
            <td>{row.class?.className}</td>
            <td>{row.manufacturer?.manufacturer}</td>
            <td>
              <div className="d-flex gap-2">
                <button
                  className="w-32-px h-32-px bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                  onClick={() => onEdit(row)}
                >
                  <Icon icon="ic:baseline-edit" className="icon text-xl line-height-1" />
                </button>
                <button
                  className="w-32-px h-32-px bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                  onClick={() => onDelete(row.id)}
                >
                  <Icon icon="ic:baseline-delete-outline" className="icon text-xl line-height-1" />
                </button>
              </div>
            </td>
          </tr>
        ))}
        {loading && (
          <tr>
            <td colSpan={5} className="text-center py-2">
              <span className="spinner-border spinner-border-sm" />
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default GroupDataTable;
